export const isFetching = (state: any) => state.isFetching;
export const groups = (state: any) => state.groups;
export const brokers = (state: any) => state.brokers;
export const lenders = (state: any) => state.lenders;
export const panel = (state: any) => state.panel;
export const audit = (state: any) => state.audit;
